import { AssetDraggableWithHandle } from '@vizit/molecules';
import * as React from 'react';

interface ProductSparkImagesGridLoadingProps {
  /**
   * Number of skeleton items to display
   * @default 6
   */
  count?: number;
  /**
   * Aria label for accessibility
   * @default "Loading generated images"
   */
  ariaLabel?: string;
  /**
   * Key prefix for skeleton items
   * @default "spark-skeleton"
   */
  keyPrefix?: string;
}

/**
 * Loading skeleton for ProductSparkImagesGrid
 */
const ProductSparkImagesGridLoading = React.memo(function ProductSparkImagesGridLoading(
  props: ProductSparkImagesGridLoadingProps,
) {
  const { count = 6, ariaLabel = 'Loading generated images', keyPrefix = 'spark-skeleton' } = props;

  return (
    <>
      {Array.from({ length: count }, (_, index) => {
        const skeletonId = `${keyPrefix}-${index}`;
        return (
          <div key={skeletonId} className="w-full max-w-[148px] min-w-0">
            <AssetDraggableWithHandle
              id={skeletonId}
              isLoading
              disabled
              score={null}
              isUnscored={false}
              isAiGenerated={false}
            >
              <AssetDraggableWithHandle.Image name="Loading..." src={null} aria-label={ariaLabel} />
            </AssetDraggableWithHandle>
          </div>
        );
      })}
    </>
  );
});

export { ProductSparkImagesGridLoading };
export type { ProductSparkImagesGridLoadingProps };
